import request, { get, put } from "./httpService";

const CUSTOMER_ENDPOINT = '/customer';

const add = (data) => {
    return request({
        method: "POST",
        url: `${CUSTOMER_ENDPOINT}/new`,
        data: data,
    });
};

const linkfamily = (primaryid, data) => {
    return request({
        method: "POST",
        url: `${CUSTOMER_ENDPOINT}/${primaryid}/linkfamily`,
        data: data,
    });
};

const unlinkFamilyMember = (primaryid, data) => {
    return request({
        method: "POST",
        url: `${CUSTOMER_ENDPOINT}/${primaryid}/unlinkfamily`,
        data: data,
    });
};

const search = (param) => {
    return request({
        method: 'GET',
        url: `${CUSTOMER_ENDPOINT}/search`,
        params: param
    })
};

const getById = (id,signal) => {
    return get({
        url: `${CUSTOMER_ENDPOINT}/${id}`,
        signal: signal
    })
}

const update = (customer) => {
    return put({
        url: `${CUSTOMER_ENDPOINT}/${customer.id}`,
        data: customer
    });
}

const remove = (customerId) => {
    return request({
        method: "DELETE",
        url: `${CUSTOMER_ENDPOINT}/${customerId}`,
    });
}

// services for insurance policy
const addInsurancePolicy = (customerId, data) => {
    return request({
        method: "POST",
        url: `${CUSTOMER_ENDPOINT}/${customerId}/insurancepolicy`,
        data: data,
    });
}
const getInsurancePolicies = (from, to, filters, sortBy, customerId, signal) => {
    return get({
        url: `${CUSTOMER_ENDPOINT}/${customerId}/insurancepolicy/${from}/${to}`,
        params: {filters: filters, sortBy: sortBy},
        signal: signal
    });
}
const updateInsurancePolicy = (customerId, policyId, data) => {
    return request({
        method: "PUT",
        url: `${CUSTOMER_ENDPOINT}/${customerId}/insurancepolicy/${policyId}`,
        data: data,
    });
}
const deleteInsurancePolicy = (customerid, rowids) => {
    return request({
        method: "DELETE",
        url: `${CUSTOMER_ENDPOINT}/${customerid}/insurancepolicy/`,
        params: {rowid: rowids}
    });
}

const applyInsurancePolicyToFamily = (customerId, policyId) => {
    return request({
        method: "POST",
        url: `${CUSTOMER_ENDPOINT}/${customerId}/insurancepolicy/${policyId}/apply`,
    });
}

const getInsurancePolicyFamilyLinks = (customerId, policyId) => {
    return get({
        url: `${CUSTOMER_ENDPOINT}/${customerId}/insurancepolicy/${policyId}/family-links`,
    });
}

const linkInsurancePolicyToCustomer = (customerId, policyId, memberId) => {
    return request({
        method: "POST",
        url: `${CUSTOMER_ENDPOINT}/${customerId}/insurancepolicy/${policyId}/link/${memberId}`,
    });
}

const unlinkInsurancePolicy = (customerId, policyId) => {
    return request({
        method: "DELETE",
        url: `${CUSTOMER_ENDPOINT}/${customerId}/insurancepolicy/${policyId}`,
    });
}

const unlinkInsurancePolicyFromFamily = (customerId, policyId) => {
    return request({
        method: "DELETE",
        url: `${CUSTOMER_ENDPOINT}/${customerId}/insurancepolicy/${policyId}/family`,
    });
}

export const CustomerService = {
    add,
    search,
    getById,
    update,
    linkfamily,
    unlinkFamilyMember,
    remove,
    addInsurancePolicy,
    updateInsurancePolicy,
    getInsurancePolicies,
    deleteInsurancePolicy,
    applyInsurancePolicyToFamily,
    getInsurancePolicyFamilyLinks,
    linkInsurancePolicyToCustomer,
    unlinkInsurancePolicy,
    unlinkInsurancePolicyFromFamily,
};